/**
 * Quick Lists & Contract
 */
(() => {
  // if ex-quicklists or ex-contractitems page
  const isQuickLists = document.querySelector('.ex-quicklists');
  const isContractItems = document.querySelector('.ex-contractitems');
  if (!isQuickLists && !isContractItems) return;

  const topGrid = document.querySelector('.topgrid');
  if (!topGrid) return;

  document.querySelector('.myaccount-title').append(document.querySelector('.topgrid'));
})();

/**
 * move stock into details
 */
(() => {
  const quicklists = document.querySelector('.ex-quicklists');
  if (!quicklists) return;

  document.addEventListener('live-inventory-done', function () {
    document.querySelectorAll('#productlist .tileparent').forEach((item) => {
      const liveInventory = item.querySelector('.live-inventory-v2-wrapper');
      const productContent = item.querySelector('.product-content');
      if (liveInventory && productContent) {
        productContent.append(liveInventory);
      }
    });
  }, false);
})();
